/**
 * Reassurance Section
 */
class Reassurance {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    // Section initialization logic
  }
}

// Initialize all reassurance sections
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="w-reassurance"]');
  sections.forEach((section) => {
    new Reassurance(section);
  });
});

// Shopify section editor support
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-reassurance"]');
    if (section) {
      new Reassurance(section);
    }
  });
}

// Expose class globally for dynamic initialization
window.Reassurance = Reassurance;
